import Crud from '../views/Cidade/Crud'
import Entity from '../views/Cidade/Add'

let routes = {
    path: '/cidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cidades/add',
            name: 'NewCidade',
            component: Entity,
            meta: {                
                perfil_id: ['1']
            },
        },
        {
            path: '/cidades/edit/:id?',
            name: 'EditCidade',
            component: Entity,
            meta: {                
                perfil_id: ['1']
            },
        },
        {
            path: '/cidades',
            name: 'list-cidades',
            component: Crud,
            meta: {
                pageTitle: 'Lista de cidades',
                breadcrumb: [
                    {
                        text: 'Cidades',
                        active: true,
                    },
                ],
                perfil_id: ['1']
            },
        },
    ]
};


export default routes
